import { Button } from '@/components/ui/button';

export function AccessCheckError({ retry }: { retry: () => void }) {
  return (
    <div role="alert" className="flex flex-col items-center justify-center gap-4 p-8 text-center">
      <p>We couldn’t verify your access. Please try again.</p>
      <Button onClick={retry}>Try again</Button>
    </div>
  );
}
